export function ErrorFallback() {
    return (
        <h2>An error has occured</h2>
    )
}